import applicationSections from '@/applicationDefinition/applicationSections'
import shelterFields from '@/applicationDefinition/shelterFields'

export function initialiseTotal(value, application) {
    if(null===application.services.total)
      application.services.total = 0.00
    application.services.total = 0.00
    application.services.rentMortgage = 0.00
    application.services.securityDeposit = 0.00
    application.services.utilities = 0.00
    application.services.carAssistance = 0.00
    application.services.transportation = 0.00
    application.services.medicalExpenses = 0.00
    application.services.food = 0.00
    application.services.childCare = 0.00
    application.services.other = 0.00

}

export function getTotal(value, application) {
    if(null===application.services.total)
      application.services.total = 0.00
    var total=
    parseFloat(application.services.rentMortgage) +
    parseFloat(application.services.securityDeposit) +
    parseFloat(application.services.utilities) +
    parseFloat(application.services.carAssistance) +
    parseFloat(application.services.transportation) +
    parseFloat(application.services.medicalExpenses) +
    parseFloat(application.services.food) +
    parseFloat(application.services.childCare) +
    parseFloat(application.services.other)
    ;

    application.services.total = total;
return total;
}

export function updateTotal(value, application) {
  const service = application.services.type   
  if(null===application.services.total)
    application.services.total = 0.00
  if (service.length === 0) {          
    initialiseTotal(value, application)
  }
  if (!service.includes('rentMortgage')) {
    application.services.rentMortgage = 0.00
    application.supportingDocuments.rentMortgage.includeFiles = false
    getTotal(value, application)
  }else{
    if(null===application.services.rentMortgage)
    application.services.rentMortgage = 0.00
  }
  if (!service.includes('securityDeposit')) {
    application.services.securityDeposit = 0.00
    application.supportingDocuments.securityDeposit.includeFiles = false
    getTotal(value, application) 
  }else{
    if(null===application.services.securityDeposit)
    application.services.securityDeposit = 0.00
    application.supportingDocuments.securityDeposit.includeFiles = true
  }
  if (!service.includes('utilities')) {
    application.services.utilities = 0.00
    application.supportingDocuments.utilities.includeFiles = false
    getTotal(value, application) 
  }else{
    if(null===application.services.utilities)
    application.services.utilities = 0.00
    application.supportingDocuments.utilities.includeFiles = true
  }
  if (!service.includes('carAssistance')) {
    application.services.carAssistance = 0.00
    application.supportingDocuments.carAssistance.includeFiles = false
    getTotal(value, application) 
  }else{
    if(null===application.services.carAssistance)
    application.services.carAssistance = 0.00
    application.supportingDocuments.carAssistance.includeFiles = true
  }
  if (!service.includes('transportation')) {
    application.services.transportation = 0.00
    application.supportingDocuments.transportation.includeFiles = false
    getTotal(value, application) 
  }else{
    if(null===application.services.transportation)
    application.services.transportation = 0.00
    application.supportingDocuments.transportation.includeFiles = true
  }
  if (!service.includes('medicalExpenses')) {
    application.services.medicalExpenses = 0.00
    application.supportingDocuments.medicalExpenses.includeFiles = false
    getTotal(value, application) 
  }else{
    if(null===application.services.medicalExpenses)
    application.services.medicalExpenses = 0.00
    application.supportingDocuments.medicalExpenses.includeFiles = true
  }
  if (!service.includes('food')) {
    application.services.food = 0.00
    getTotal(value, application) 
  }else{
    if(null===application.services.food)
    application.services.food = 0.00
  }
  if (!service.includes('childCare')) {
    application.services.childCare = 0.00
    application.supportingDocuments.childCare.includeFiles = false
    getTotal(value, application) 
  }else{
    if(null===application.services.childCare)
    application.services.childCare = 0.00
    application.supportingDocuments.childCare.includeFiles = true
  }
  if (!service.includes('other')) {
    application.services.other = 0.00
    application.supportingDocuments.other.includeFiles = false
    getTotal(value, application) 
  }else{
    if(null===application.services.other)
    application.services.other = 0.00
    application.supportingDocuments.other.includeFiles = true
  }
}

export const enableShelterSection = (value, application) => {
      const service = application.services.type
      if (service.length === 0) {
        removeShelterSection()
      }
      if (service.includes('rentMortgage') || service.includes('securityDeposit')) {
        removeShelterSection()
        var shelterSection =  {
          id: 'shelter',
          label: 'Shelter Verification',
          fields: shelterFields
        }
        const identityIndex = applicationSections.findIndex(
          item => item.id === 'identityProof'
        )
        const insertAt = identityIndex === -1 ? applicationSections.length : identityIndex + 1
        applicationSections.splice(insertAt,0,shelterSection)
      }else{
        removeShelterSection()
      }
     
}

export function removeShelterSection() {
  const shelterIndex = applicationSections.findIndex(
    item => item.id === 'shelter'
  )
  if(shelterIndex!=-1){
    applicationSections.splice(shelterIndex,1)
  }

}
